export const INVESTMENT = 'Investments';
export const EXPLORE = 'Explore';
export const EXPLORE_MUTUAL_FUNDS = 'Explore Mutual Funds';
export const PORTFOLIO = 'Portfolio';
export const QUICK_ACCESS = 'Quick Access';
export const FAQS = 'FAQs'; 
export const LOGIN_TO_VIEW_PORTFOLIO = 'Login to View Portfolio';
export const INVEST = 'Invest';
export const MY_PROFILE = 'My Profile';
export const USER_GUIDE = 'User Guide';
